import logo from '../assets/images/businessbackground.jpg';
import logo2 from '../assets/images/timesheetbackground.jpeg';
const Authlayout = ({children}) =>{

  const divStyle = {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100vh',
    backgroundColor: '#24416c' // Adjust height as needed
  };

   return(
     <>
      <div style={divStyle}>
       {children}
       </div>
     </>
   );   
}

export default Authlayout;